module.exports = __webpack_public_path__ + "img/product_18.817d5bc.jpg";